import {mergeAttributes} from "@tiptap/core";
import Bold from "@tiptap/extension-bold";

// Preserve <b> tags for bold
export const CustomBold_b = Bold.extend({
	name: "bold",
	parseHTML() {
		return [
			{
				tag:      "b",
				getAttrs: node => (node as any).style.fontWeight !== "normal" && null
			}, {
				style:    "font-weight",
				getAttrs: value => /^(bold(er)?|[5-9]\d{2,})$/.test(value) && null
			}
		];
	},
	renderHTML({HTMLAttributes}) {
		return ["b", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
	}
});
